const STORAGE_KEY = 'contentManagementFilters';

export const loadContentManagementFilters = (tabId) => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const data = raw ? JSON.parse(raw) : {};
    return data[tabId] || { filters: {}, count: 0 };
  } catch (error) {
    return { filters: {}, count: 0 };
  }
};

export const saveContentManagementFilters = (tabId, filters, count) => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const data = raw ? JSON.parse(raw) : {};
    data[tabId] = { filters, count };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    window.dispatchEvent(new CustomEvent('contentManagementFiltersUpdated'));
  } catch (error) {
    // ignore storage errors
  }
};

export const getAllContentManagementFilterCounts = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const data = raw ? JSON.parse(raw) : {};
    return Object.keys(data).reduce((acc, tabId) => {
      acc[tabId] = Number(data[tabId]?.count) || 0;
      return acc;
    }, {});
  } catch (error) {
    return {};
  }
};
